import { render, staticRenderFns } from "./CaixaListagem.vue?vue&type=template&id=cda9af54&scoped=true"
import script from "./CaixaListagem.vue?vue&type=script&lang=js"
export * from "./CaixaListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda9af54",
  null
  
)

export default component.exports